import React from "react";

/**
 * Decorative hexagon-cluster brand mark inspired by the Magee logo.
 * Renders as pure SVG so it scales cleanly and can be tinted / faded.
 * Use as absolute positioned decoration inside a `relative` parent.
 */
export function HexMark({
  size = 200,
  className = "",
  opacity = 0.08,
  variant = "cluster", // 'cluster' | 'single'
}) {
  if (variant === "single") {
    return (
      <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        className={className}
        style={{ opacity }}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="hex-single" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#7FB2E0" />
            <stop offset="50%" stopColor="#2A7DE1" />
            <stop offset="100%" stopColor="#0B2545" />
          </linearGradient>
        </defs>
        <polygon
          points="50,3 90,25 90,75 50,97 10,75 10,25"
          fill="url(#hex-single)"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 220 220"
      width={size}
      height={size}
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="hex-a" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7FB2E0" />
          <stop offset="100%" stopColor="#2A7DE1" />
        </linearGradient>
        <linearGradient id="hex-b" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2A7DE1" />
          <stop offset="100%" stopColor="#0B2545" />
        </linearGradient>
        <linearGradient id="hex-c" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#0B2545" />
          <stop offset="100%" stopColor="#1E5FBF" />
        </linearGradient>
      </defs>
      {/* Cluster of 7 hexagons (honeycomb) */}
      <g>
        <polygon points="110,10 158,38 158,88 110,116 62,88 62,38" fill="url(#hex-a)" />
        <polygon points="62,88 110,116 110,166 62,194 14,166 14,116" fill="url(#hex-b)" />
        <polygon points="158,88 206,116 206,166 158,194 110,166 110,116" fill="url(#hex-c)" />
        <polygon
          points="86,50 110,64 110,90 86,104 62,90 62,64"
          fill="#F0F7FF"
          opacity="0.65"
        />
        <polygon
          points="134,50 158,64 158,90 134,104 110,90 110,64"
          fill="#7FB2E0"
          opacity="0.9"
        />
      </g>
    </svg>
  );
}

export default HexMark;
